<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>账号</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">签约主体</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddShow && !hideInUserEdit">
      <section class="searchBoxTwo">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            >增加</a-button
          >
        </span>
        <span class="searchStyle">
          <a-input
            v-model="nameSearch"
            placeholder="请输入公司名称"
            style="margin-right:20px;"
          />
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.company_name }}</td>
              <td>{{ item.short_name }}</td>
              <td>
                <span v-for="(element, i) in item.department_info" :key="i">
                  <span v-show="i != 0 && i > 0">|</span>
                  <span>{{ element.department_name }}</span>
                </span>
              </td>
              <td class="operation">
                <a @click="edit(item)">编辑</a>
                <a
                  @click="onDisable(item.id)"
                  v-if="item.status == 0"
                  style="color:#666"
                  >禁用</a
                >
                <a @click="onTestore(item.id)" v-if="item.status == 1">恢复</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addCompany v-on:hideInAdd="hideInAdd" v-if="hideInAddShow" />
    <!-- 增加 end-->
    <!-- 编辑 -->
    <companyEdit
      v-on:hideInEdit="hideInEdit"
      v-show="hideInUserEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
  </div>
</template>
<script>
import axios from "axios";
import addCompany from "@/components/setting/addCompany"; //增加公司
import companyEdit from "@/components/setting/companyEdit"; //编辑用户
import { mapState } from "vuex";

export default {
  components: {
    addCompany,
    companyEdit
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      typeSearch: -1,
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      nameSearch: "",
      thList: ["公司名称", "公司简称", "部门", "操作"]
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInAddShow = false;
      this.hideInUserEdit = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.customer + "Company/companyList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.nameSearch,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    },
    onDisable(id) {
      const self = this;
      this.$confirm({
        title: "禁用账号?",
        content: "账号一旦禁用，将无法使用系统!",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          let url =
            self.httpsBasic.url + self.httpsBasic.user + "User/setUserStatus";
          axios
            .post(url, {
              token: window.localStorage.getItem("xnwfPcToken"),
              user_id: id,
              status: 1
            })
            .then(res => {
              if (res.data.code == 200) {
                self.$message.success("禁用成功");
                self.getData();
              } else {
                self.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              self.$message.error("服务器出错啦...");
            });
        },
        onCancel() {}
      });
    },
    onTestore(id) {
      const self = this;
      this.$confirm({
        title: "恢复账号?",
        content: "确定恢复其账号的使用权限!",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          let url =
            self.httpsBasic.url + self.httpsBasic.user + "User/setUserStatus";
          axios
            .post(url, {
              token: window.localStorage.getItem("xnwfPcToken"),
              user_id: id,
              status: 0
            })
            .then(res => {
              if (res.data.code == 200) {
                self.$message.success("操作成功");
                self.getData();
              } else {
                self.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              self.$message.error("服务器出错啦...");
            });
        },
        onCancel() {}
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
